export default __webpack_public_path__ + "static/media/Employees_Oswestry-Low Back Pain Scale.af00a926.pdf";